import DirectoryList from './DirectoryList';
import useDirectories from './useDirectories';

function DirectoryListContainer() {
  const { directories } = useDirectories();
  return <DirectoryList directories={directories} />;
}

export default DirectoryListContainer;
